import React from "react";
import { Link } from "react-router-dom";
import "../../style/component/HomePage/Card.css";
function Card({ items = [] }) {
  return (
    <div className="card-grid">
      {items.map((item, index) => (
        <Link key={index} to={`/${item.category.replace("_", "-")}`} className="card" data-track={item.category}>
          <h2 className="card-title" data-translate={`cards.${item.category}.title`}>
            {item.title}
          </h2>
          <p className="card-description" data-translate={`cards.${item.category}.description`}>
            {item.description}
          </p>
        </Link>
      ))}
    </div>
  );
}
export default Card;
